export default function DashboardNotesModalController($scope, $uibModalInstance, alert, alertsRepository, usersService, gettextCatalog) {

  'ngInject';

  $scope.alert = alert;
  $scope.editing = {};
  $scope.editNote = {};
  $scope.loading = true;
  $scope.creatingnote = false;
  $scope.postingChange = false;
  var userEmail = "";

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.close = function () {
    alert.noteCount = $scope.notes.length;
    $uibModalInstance.close(alert);
  };

  $scope.$on('$locationChangeStart', function (event, next, current) {
    $scope.cancel();
    event.preventDefault();
  });

  $scope.toggleEditing = function (note) {
    $scope.editing[note.id] = !$scope.editing[note.id];
    $scope.editNote.text = note.text;
  };

  $scope.cancelEdit = function (note) {
    $scope.editing[note.id] = !$scope.editing[note.id];
    $scope.editNote.text = "";
  };

  //C.R.U.D Methods for Notes
  $scope.getAlertNotes = function (alert) {
    $scope.loading = true;
    alertsRepository.getNotes(alert.instanceId)
      .then(function (response) {

        var data = response.data;
        for (var i = 0; i < data.length; i++) {
          var date = moment(data[i].updatedAt).fromNow();

          data[i].date = date;
          data[i]._editable = usersService.currentUser().id == data[i].noteUserId;
        }

        $scope.notes = data;

        $scope.loading = false;
      }, function (error) {
        var errorMsg = gettextCatalog.getString("An error occurred while retrieving alert notes");
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + " " + (error.status.toString() + " - " + error.statusText.toString());
          } else {
            errorMsg += ": " + (error.status.toString() + " - " + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString(". Please try again later.");
        }
        $scope.onLoadErrorFlag = true;
        $scope.onLoadErrorText = errorMsg;
        $scope.loading = false;
      });
  }; //getAlertNotes

  $scope.getAlertNotes($scope.alert);

  $scope.createNewNote = function (noteText) {
    $scope.creatingnote = true;
    var note = {};

    userEmail = usersService.currentUser().email;

    note["instanceId"] = alert.instanceId;
    note["text"] = noteText;
    note["enteredBy"] = userEmail;
    note["updatedBy"] = userEmail;

    alertsRepository.createNote(note.instanceId, note).then(function () {
      $scope.getAlertNotes($scope.alert);
      $scope.creatingnote = false;
      $scope.newNote.text = "";
    }, function (error) {
      var errorMsg = gettextCatalog.getString("An error occurred while creating the note");
      if (error.data || error.status) {
        if (error.data.message) {
          errorMsg = error.data.message + " " + (error.status.toString() + " - " + error.statusText.toString());
        } else {
          errorMsg += ": " + (error.status.toString() + " - " + error.statusText.toString());
        }
      } else {
        errorMsg += gettextCatalog.getString(". Please try again later.");
      }
      $scope.errorFlag = true;
      $scope.errorText = errorMsg;
      $scope.creatingnote = false;
    });
  };

  $scope.updateNote = function (alertId, noteId, note) {
    if ($scope.editNote.text != "") {
      userEmail = usersService.currentUser().email;

      note.updatedBy = userEmail;
      note.text = $scope.editNote.text;
      $scope.postingChange = true;

      alertsRepository.updateNote(alertId, noteId, note)
        .then(function (response) {
          $scope.editing[note.id] = !$scope.editing[note.id];
          $scope.postingChange = false;

        }, function (error) {
          var errorMsg = gettextCatalog.getString("An error occurred while updating the note");
          if (error.data || error.status) {
            if (error.data.message) {
              errorMsg = error.data.message + " " + (error.status.toString() + " - " + error.statusText.toString());
            } else {
              errorMsg += ": " + (error.status.toString() + " - " + error.statusText.toString());
            }
          } else {
            errorMsg += gettextCatalog.getString(". Please try again later.");
          }
          $scope.errorFlag = true;
          $scope.errorText = errorMsg;
          $scope.postingChange = false;
        });
    } else {
      $scope.isInvalidData = true;
    }

  }; //update note

  $scope.deleteNote = function (alertId, noteId) {
    alertsRepository.deleteNote(alertId, noteId)
      .then(function (response) {
        $scope.getAlertNotes($scope.alert);
      }, function (error) {
        var errorMsg = gettextCatalog.getString("An error occurred while deleting the note");
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + " " + (error.status.toString() + " - " + error.statusText.toString());
          } else {
            errorMsg += ": " + (error.status.toString() + " - " + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString(". Please try again later.");
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
      });
  };
}